export const normalExchangeTypes = [
  { id: 1, name: 'NORMAL' },
  { id: 2, name: 'MERGER' },
]
export const statExchangeTypes = [
  { id: 1, name: 'NORMAL' },
  { id: 2, name: 'MERGER' },
  { id: 3, name: 'NAIC' },
]
